module.exports = __webpack_public_path__ + "img/success.4043a153.png";